import request from './request'
import { reportUrl } from '@tencent/smp-tools'
import { Base64 } from 'js-base64';
import {get} from 'lodash';
import { GET_REPORT_DATA, POST_REPORT_DATA_BULK } from '../urls'
import { query, detectEnv, getShareParams, getUserKey } from './yUtil.js'
import {getArticleIdFromUrl, getVideoIdFromUrl} from './yUtil';
import { getAppName, getSourceAppName } from './appBase'
import { isTBS, isQQBrowser } from './UA'
import { profileMatch } from './index'
import { getGuid as _getGuid } from './qbjsapi';
import { handleUgData } from './ug'
const appName = getAppName()
const sourceAppName = getSourceAppName()
const env = detectEnv()
const commonParams = getShareParams()
const userKey = getUserKey()

const getGuid = () => {
  if (commonParams.sGuid) {
    return commonParams.sGuid
  }

  if (isQQBrowser(window.navigator.userAgent)) {
    return _getGuid()
  }
}

/**
 * @desc 获取分享者锁命中的实验ID
 *
 */
const getUProfileId = async () => {
  try {
    const matched = await profileMatch()
  
    return Array.isArray(matched) ? matched.join('&') : matched
  } catch (error) {
    return null
  }
}

const fromApp = query('from_app') || 'qb'

let contentType = null

if (window.location.pathname.includes('/video/')) {
  if (window.location.search.includes('classify=1')) {
    contentType = 3
  } else {
    contentType = 2
  }
} else if (window.location.pathname.includes('/shortContent')) {
  contentType = 4
} else {
  contentType = 1
}

// 浏览器=10001(默认) 快报=10002  快报快捷桌面=10003  QQ看点=10004  浏览器10.0以下版本=10005
const appIdList = {
  'qb': 10001,
  'kb': 10002,
  'kbapk': 10003,
  'qqkd': 10004,
  'qb_10': 10005
}

const reportDataCommon = {
  user_action: '',
  action_platform: env.isWeChat ? 1 : (env.isMQQ ? 2 : (env.isQB ? 0 : (env.isQZone ? 3 : 4))),
  business_id: query('sBusinessID') || '',    // 业务场景
  source_id: query('source_id') || '',        // 来源：1:二次分享
  profileid: query('sProfileID') || '',       // 分享者实验ID
  appid: appIdList[fromApp],                                  // 分享来源APP的ID
  s_userId: commonParams.sUserId || '',                       // 分享者用户id
  s_guid: commonParams.sGuid || '',           // 分享者guid \ omgid
  system_platform: env.isIos ? 1 : (env.isAndroid ? 2 : 3),   // 系统平台 IOS：1 android：2 其他：3
  u_profileid: '',                                            // 被分享者实验ID
  target_appid: appIdList[appName],                           // 分享目标APP的ID
  source_appName: sourceAppName,  // 来源应用名称
  content_type: contentType,                                            // 业务场景（分享曝光的内容类型）: 第三方网页=0 图文=1 短视频=2 小视频=3 小视频新UI 4(临时兼容)
  docId: getArticleIdFromUrl() || '',                         // 文章ID
  article_title: '',                                          // 文章标题, 热搜名
  channel: 'new_ui',                                          // 新UI数据上报，全量后需要需要改为 query('ch')
  app_status: -1,                                             // app安装状态 1:已安装 2:未安装 -1:默认其他
  user_key: userKey,                                          // 用户标志，用于统计uv
  is_tbs: isTBS(window.navigator.userAgent) ? 1 : 2,           // 判断是否TBS环境 1:是  2: 否
  local_app_status: 'qb=-1&kb=-1', // 应用安装状态
  subjectId: '' // 内容话题分类
}


// 定义一个延迟函数，简化 Promise 的使用
const deferred = function () {
  const obj = {};

  obj.promise = new Promise(function (resolve, reject) {
    obj.resolve = resolve;
    obj.reject = reject;
  });

  return obj;
}

/**
 * 合并参数请求
 */
const debounce = function (fn, millisec, threshold) {
  if (typeof fn !== 'function') {
    throw new TypeError('fn must be function type.')
  }
  if (!(typeof millisec === 'number' && Math.floor(millisec) === millisec && millisec > 0)) {
    throw new TypeError('The millisec must be a positive integer.')
  }
  if (!(typeof threshold === 'number' && Math.floor(threshold) === threshold && threshold > 0)) {
    throw new TypeError('The threshold must be a positive integer.')
  }

  // 进行中的任务
  let task = null;
  // 待执行的多次请求参数的数组
  let parameters = [];
  // 待连接的延迟对象数组
  let promises = [];

  return function () {
    // 在规定的时间内多次调用，取消前一次的等待效果
    if (task !== null) {
      clearTimeout(task);

      task = null;
    }

    // 缓存本次调用的参数
    for (let i = 0; i < arguments.length; i++) {
      parameters.push(arguments[i]);
    }

    // 定义本次调用的返回值
    const defer = deferred();

    // 保存本次的延迟对象，使得后续连接可用
    promises.push(defer);

    // 需要执行的延迟函数封装
    const callback = function () {
      // 本次延迟已正确执行，取消延迟函数标识
      task = null;

      let tmpParameters = parameters;
      parameters = [];

      let tmpPromises = promises;
      promises = [];

      // 执行目标函数并捕获返回值
      let delay = Promise.resolve().then(function () {
        return fn(tmpParameters);
      });

      // 触发请求的数据回调
      tmpPromises.forEach(function (v) {
        delay.then(v.resolve, v.reject).then(null, function (e) {
          console.error(e);
        });
      });
    };

    // 参数数量达到阈值限制时，取消延迟直接执行
    if (parameters.length >= threshold) {
      callback();
    } else {
      task = setTimeout(callback, millisec);
    }

    // 保持本次请求后续操作的延迟对象
    return defer.promise;
  };
}

const report = debounce((params) => {
 request.post(POST_REPORT_DATA_BULK, {
    params
  })
}, 500, 10)

const reportBulk = (args) => {
  report(args)
}

export async function statTicket(params = {}) {
  console.log('params.user_action', params.user_action)

  const [ s_guid, u_profileid ] = await Promise.all([
    getGuid(),
    getUProfileId()
  ])

  reportBulk(Base64.encode(JSON.stringify(Object.assign({}, reportDataCommon, params, {
    s_guid,
    u_profileid,
    timestamp: new Date().getTime(),
    target_appid: appIdList[getAppName()]
  }))))

  try {    
    const smpStatUrl = window.SMP_STAT_URL
    if(smpStatUrl){
      reportUrl({
        statUrl: smpStatUrl,
        action: params.user_action
      })
    }
  } catch (error) {
    console.log(error)
  }
}

export const statTicketSync = async (params = {}) => {
  console.log('params.user_action', params.user_action)

  const [ s_guid, u_profileid ] = await Promise.all([
    getGuid(),
    getUProfileId()
  ])

  request.get(GET_REPORT_DATA, {
    data: Base64.encode(JSON.stringify(Object.assign({}, reportDataCommon, params, {
      s_guid,
      u_profileid,
      timestamp: new Date().getTime()
    })))
  })

  try {    
    const smpStatUrl = window.SMP_STAT_URL
    if(smpStatUrl){
      reportUrl({
        statUrl: smpStatUrl,
        action: params.user_action
      })
    }
  } catch (error) {
    console.log(error)
  }
}

export const fillReportStringItemId = (str = '') => {
  let res = str;
  try {
    const itemID = getArticleIdFromUrl() || getVideoIdFromUrl();
    if (typeof (str) === 'string' && str) {
      if (str.indexOf('&itemid=') > -1) {
        const strArr = str.split('&');
        strArr.forEach((item, index) => {
          if (item === 'itemid=') {
            strArr[index] = `itemid=${itemID}`;
          }
        });
        res = strArr.join('&');
      } else {
        res = `${str}&itemid=${itemID}`;
      }
    }
  }catch (e) {

  }
  return res;
};

export const reportUg = async (action, subpos, rest = {}) => {
  if (!window.ugData) {
    await handleUgData();
  }
  try {
    const statInfo = window.ugData.statInfo[999];
    let str = '';
    for(let key in rest) {
      str = `${str}&${key}=${rest[key]}`;
    }
    statInfo.map(item => {
      console.debug('上报UG', `${item}&acttype=${action}&subpos=${subpos || window.subpos || ''}${str}`)
      new Image().src =  `${fillReportStringItemId(item)}&acttype=${action}&subpos=${subpos || window.subpos || ''}${str}`;
    })
  }catch (e) {
    console.error('上报异常', e);
  }
}


const ecommerceCommon = {
  share_id: query('shareId') || '',
  share_guid: query('shareGuid') || '',
  share_user_type: query('type') || '',
  activity_id: query('activityId') || '',
  commodity_id: query('id') || '',
  platform: `${env.isWeChat ? 1 : (env.isMQQ ? 2 : (env.isQB ? 0 : (env.isQZone ? 3 : 4)))}`,
  is_tbs: `${isTBS(window.navigator.userAgent) ? 1 : 2}`,           // 判断是否TBS环境 1:是  2: 否,
}

export function generateUgExtStat(rest = {}) {
  const {uin = '', type = ''} = window.userInfo || {};
  const eCommerce = window.ecommerceInfo || {};
  const statch =  query('ch') || '';
  const params = {...ecommerceCommon, uin, type, ...rest, ...eCommerce};
  let str = '';
  for(let key in params) {
    str = str ? `${str}&${key}=${params[key] || ''}` : `${key}=${params[key] || ''}`;
  }

  return `&statch=${statch}&ext_mpdata=${encodeURIComponent(str)}`;
}
export const reportEcommerce = async (action, subpos, rest = {}) => {
  try {
    const stat = get(window, 'ugData.statInfo[999]', '');
    const url = `${stat}&acttype=${action}&subpos=${subpos || window.subpos || ''}${generateUgExtStat(rest)}`;
    console.log('上报链接', url);
    new Image().src = url
  }catch (e) {
    console.log('上报异常', e.message);
  }
}


export const reportMonitor = async (name) => {
  try {
    await request.get("/api/stat/reportMonitor", {
      name
    })
  }catch (e) {
    console.log('reportMonitor error', e.message);
  }
}

